/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import get from 'lodash/fp/get.js';
import pipe from 'lodash/fp/pipe.js';
import { connect } from 'react-redux';
import { change, reduxForm, SubmissionError, untouch } from 'redux-form';
import withNavigate from '#components/support/routing/withNavigate/index.jsx';
import { postUser } from '#actions/users/users.js';
import { PROBLEM_WITH_REQUEST } from '#constants/errorMessages.js';
import { USER_EMAIL_ALREADY_EXISTS } from '#constants/users/errorMessages.js';
import calculateUserRequestPostBody from '#support/users/calculateUserRequestPostBody.js';
import { CREATE_USER } from '#constants/users/form/createUser/name.js';
import { selectHasTouchedFields } from '#selectors/ui/form/admin/user/createUser.js';
import CreateUserForm from './CreateUserForm.jsx';

const makeOnSubmit = (dispatch, navigate) => values => {
  const shouldAddAnother = values.addAdditional;

  return dispatch(postUser(calculateUserRequestPostBody(values)))
    .then(() => {
      if (shouldAddAnother) {
        dispatch(change(CREATE_USER, 'firstName', ''));
        dispatch(change(CREATE_USER, 'lastName', ''));
        dispatch(change(CREATE_USER, 'email', ''));
        dispatch(change(CREATE_USER, 'isAdmin', false));
        dispatch(
          untouch(
            CREATE_USER,
            'firstName',
            'lastName',
            'email',
            'isAdmin',
            'orgId',
            'addAdditional'
          )
        );
      } else {
        navigate('..');
      }
    })
    .catch(action => {
      const serverMessage = get('payload.message', action);
      const message = [USER_EMAIL_ALREADY_EXISTS].includes(serverMessage)
        ? serverMessage
        : PROBLEM_WITH_REQUEST;
      return Promise.reject(new SubmissionError({ _error: message }));
    });
};

const mapStateToProps = state => ({
  hasTouchedFields: selectHasTouchedFields(state),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onSubmit: makeOnSubmit(dispatchProps.dispatch, ownProps.navigate),
});

const addForm = reduxForm({
  form: CREATE_USER,
})(CreateUserForm);

export default pipe(connect(mapStateToProps, undefined, mergeProps), withNavigate)(addForm);
